import { Component, useState } from 'react'
import { Col, Row, Input } from 'reactstrap'
import AdvancedFilters from '../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../Filters/filterUrl'
import { countVisibleFilters } from '../Filters/presetFilters'

// Small function control so this class header can host the hooks-based Advanced
// Filters popover. Advanced filters live in the URL (useAdvancedFilters); the
// editable is_archived preset is owned by the container and passed down so the
// popover, the chips, and the list query all share one source of truth.
function LiabilityAdvancedFiltersControl({ presets, setPresets }) {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger compact count={countVisibleFilters(presets, advancedFilters)} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="liability_claim"
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                    presets={presets}
                    onPresetsChange={setPresets}
                />
            )}
        </>
    )
}

class LiabilityClaimListHeader extends Component {
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    render() {
        return (
            <Row className="pb-2">
                <Col xs={12} className="mt-2">
                    <Row className="align-items-center">
                        <Col>
                            <span className="driver-search-filter">
                                <Input
                                    type="text"
                                    name="searchTerm"
                                    placeholder="Search"
                                    onChange={(e) => this.updateSearchTerm(e.target.value)}
                                />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="p-0">
                            <LiabilityAdvancedFiltersControl
                                presets={this.props.presets}
                                setPresets={this.props.setPresets}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="liability_claim"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}

export default LiabilityClaimListHeader
